import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

import { getComponentFormError } from '../../../utils';

interface Props {
  label: string;
  name: string;
  defaultValue?: string;
  [key: string]: any;
  rows?: number;
  readOnly?: boolean;
}

function TextArea(props: Props) {
  const {
    register,
    formState: { errors }
  } = useFormContext();
  const { label, name, defaultValue, readOnly } = props;
  const error = getComponentFormError(name, errors);
  const rows = props.rows ? props.rows : 3;

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        defaultValue={defaultValue}
        as="textarea"
        rows={rows}
        {...register(name)}
        isInvalid={error ? true : false}
        readOnly={readOnly}
      />
      <Form.Control.Feedback type="invalid">{error ? error.message : ''}</Form.Control.Feedback>
    </Form.Group>
  );
}

export default TextArea;
